import React, { useContext } from "react";
import styles from './styles/CheckEmail.module.css';
import { formatEmail } from "../../Utils/formatEmail";
import { LanguageContext } from "../../Context/changeLanguageProvider";


export function CheckEmail({ title = "Please Check Your Email", email_address, onBack }) {
    window.scrollTo(0,0)
    const websiteCurrentLang = useContext(LanguageContext ).language;
    const dublicatedcontent = websiteCurrentLang.content.DublicatedText

    return (
        <div className={styles.main}>
            <div className={styles.title}>{title}</div>
            <div className={styles.card}>
                <div className={styles.top}>
                    {email_address &&
                    <>
                        <div>{dublicatedcontent?.activation_emails_has_been_sent_to}</div>
                    
                        <div className={styles.bold}>{formatEmail(email_address)}</div>
                    </>
                    }
                </div>

                <div className={styles.middle}>
                    <div>{dublicatedcontent?.please_check_inbox}</div>
                </div>
                <div>
                    <div className={styles.bold}>{dublicatedcontent?.wrong_email_address_registration}</div>
                    <div onClick={() => onBack()} className={styles.onBack}>{dublicatedcontent?.click_to_go_back}</div>
                </div>
            </div>
        </div>
    )
}